
export enum TrainingStatusValue {
  Contact = 'contact',
  Appointed = 'train',
  Reschedule = 'reschedule',
  Completed = 'completed',
  Declined = 'declined',
}
